import { createFileRoute } from '@tanstack/react-router'

import { NnppImportVerificationPage } from '@/src/pages/nnpp/imports/NnppImportVerificationPage'

export const Route = createFileRoute(
  '/nnpp/imports/$importId/documents/$documentId/import-verification'
)({
  component: NnppImportVerificationPage,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})
